/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "учора",
        "-2": "позавчора",
        "0": "сьогодні",
        "1": "завтра",
        "2": "післязавтра",
        "future": {
          "few": "через {0} дні",
          "many": "через {0} днів",
          "one": "через {0} день",
          "other": "через {0} дня"
        },
        "past": {
          "few": "{0} дні тому",
          "many": "{0} днів тому",
          "one": "{0} день тому",
          "other": "{0} дня тому"
        }
      },
      "day-narrow": {
        "-1": "учора",
        "-2": "позавчора",
        "0": "сьогодні",
        "1": "завтра",
        "2": "післязавтра",
        "future": {
          "few": "за {0} д.",
          "many": "за {0} д.",
          "one": "за {0} д.",
          "other": "за {0} д."
        },
        "past": {
          "few": "{0} дн. тому",
          "many": "{0} дн. тому",
          "one": "{0} дн. тому",
          "other": "{0} дн. тому"
        }
      },
      "day-short": {
        "-1": "учора",
        "-2": "позавчора",
        "0": "сьогодні",
        "1": "завтра",
        "2": "післязавтра",
        "future": {
          "few": "через {0} дн.",
          "many": "через {0} дн.",
          "one": "через {0} дн.",
          "other": "через {0} дн."
        },
        "past": {
          "few": "{0} дн. тому",
          "many": "{0} дн. тому",
          "one": "{0} дн. тому",
          "other": "{0} дн. тому"
        }
      },
      "hour": {
        "0": "цієї години",
        "future": {
          "few": "через {0} години",
          "many": "через {0} годин",
          "one": "через {0} годину",
          "other": "через {0} години"
        },
        "past": {
          "few": "{0} години тому",
          "many": "{0} годин тому",
          "one": "{0} годину тому",
          "other": "{0} години тому"
        }
      },
      "hour-narrow": {
        "0": "цієї години",
        "future": {
          "few": "за {0} год",
          "many": "за {0} год",
          "one": "за {0} год",
          "other": "за {0} год"
        },
        "past": {
          "few": "{0} год тому",
          "many": "{0} год тому",
          "one": "{0} год тому",
          "other": "{0} год тому"
        }
      },
      "hour-short": {
        "0": "цієї години",
        "future": {
          "few": "через {0} год",
          "many": "через {0} год",
          "one": "через {0} год",
          "other": "через {0} год"
        },
        "past": {
          "few": "{0} год тому",
          "many": "{0} год тому",
          "one": "{0} год тому",
          "other": "{0} год тому"
        }
      },
      "minute": {
        "0": "цієї хвилини",
        "future": {
          "few": "через {0} хвилини",
          "many": "через {0} хвилин",
          "one": "через {0} хвилину",
          "other": "через {0} хвилини"
        },
        "past": {
          "few": "{0} хвилини тому",
          "many": "{0} хвилин тому",
          "one": "{0} хвилину тому",
          "other": "{0} хвилини тому"
        }
      },
      "minute-narrow": {
        "0": "цієї хвилини",
        "future": {
          "few": "за {0} хв",
          "many": "за {0} хв",
          "one": "за {0} хв",
          "other": "за {0} хв"
        },
        "past": {
          "few": "{0} хв тому",
          "many": "{0} хв тому",
          "one": "{0} хв тому",
          "other": "{0} хв тому"
        }
      },
      "minute-short": {
        "0": "цієї хвилини",
        "future": {
          "few": "через {0} хв",
          "many": "через {0} хв",
          "one": "через {0} хв",
          "other": "через {0} хв"
        },
        "past": {
          "few": "{0} хв тому",
          "many": "{0} хв тому",
          "one": "{0} хв тому",
          "other": "{0} хв тому"
        }
      },
      "month": {
        "-1": "минулого місяця",
        "0": "цього місяця",
        "1": "наступного місяця",
        "future": {
          "few": "через {0} місяці",
          "many": "через {0} місяців",
          "one": "через {0} місяць",
          "other": "через {0} місяця"
        },
        "past": {
          "few": "{0} місяці тому",
          "many": "{0} місяців тому",
          "one": "{0} місяць тому",
          "other": "{0} місяця тому"
        }
      },
      "month-narrow": {
        "-1": "мин. міс.",
        "0": "цього міс.",
        "1": "наст. міс.",
        "future": {
          "few": "за {0} міс.",
          "many": "за {0} міс.",
          "one": "за {0} міс.",
          "other": "за {0} міс."
        },
        "past": {
          "few": "{0} міс. тому",
          "many": "{0} міс. тому",
          "one": "{0} міс. тому",
          "other": "{0} міс. тому"
        }
      },
      "month-short": {
        "-1": "минулого місяця",
        "0": "цього місяця",
        "1": "наступного місяця",
        "future": {
          "few": "через {0} міс.",
          "many": "через {0} міс.",
          "one": "через {0} міс.",
          "other": "через {0} міс."
        },
        "past": {
          "few": "{0} міс. тому",
          "many": "{0} міс. тому",
          "one": "{0} міс. тому",
          "other": "{0} міс. тому"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "минулого кварталу",
        "0": "цього кварталу",
        "1": "наступного кварталу",
        "future": {
          "few": "через {0} квартали",
          "many": "через {0} кварталів",
          "one": "через {0} квартал",
          "other": "через {0} кварталу"
        },
        "past": {
          "few": "{0} квартали тому",
          "many": "{0} кварталів тому",
          "one": "{0} квартал тому",
          "other": "{0} кварталу тому"
        }
      },
      "quarter-narrow": {
        "-1": "минулого кв.",
        "0": "цього кв.",
        "1": "наступного кв.",
        "future": {
          "few": "за {0} кв.",
          "many": "за {0} кв.",
          "one": "за {0} кв.",
          "other": "за {0} кв."
        },
        "past": {
          "few": "{0} кв. тому",
          "many": "{0} кв. тому",
          "one": "{0} кв. тому",
          "other": "{0} кв. тому"
        }
      },
      "quarter-short": {
        "-1": "минулого кв.",
        "0": "цього кв.",
        "1": "наступного кв.",
        "future": {
          "few": "через {0} кв.",
          "many": "через {0} кв.",
          "one": "через {0} кв.",
          "other": "через {0} кв."
        },
        "past": {
          "few": "{0} кв. тому",
          "many": "{0} кв. тому",
          "one": "{0} кв. тому",
          "other": "{0} кв. тому"
        }
      },
      "second": {
        "0": "зараз",
        "future": {
          "few": "через {0} секунди",
          "many": "через {0} секунд",
          "one": "через {0} секунду",
          "other": "через {0} секунди"
        },
        "past": {
          "few": "{0} секунди тому",
          "many": "{0} секунд тому",
          "one": "{0} секунду тому",
          "other": "{0} секунди тому"
        }
      },
      "second-narrow": {
        "0": "зараз",
        "future": {
          "few": "за {0} с",
          "many": "за {0} с",
          "one": "за {0} с",
          "other": "за {0} с"
        },
        "past": {
          "few": "{0} с тому",
          "many": "{0} с тому",
          "one": "{0} с тому",
          "other": "{0} с тому"
        }
      },
      "second-short": {
        "0": "зараз",
        "future": {
          "few": "через {0} с",
          "many": "через {0} с",
          "one": "через {0} с",
          "other": "через {0} с"
        },
        "past": {
          "few": "{0} с тому",
          "many": "{0} с тому",
          "one": "{0} с тому",
          "other": "{0} с тому"
        }
      },
      "week": {
        "-1": "минулого тижня",
        "0": "цього тижня",
        "1": "наступного тижня",
        "future": {
          "few": "через {0} тижні",
          "many": "через {0} тижнів",
          "one": "через {0} тиждень",
          "other": "через {0} тижня"
        },
        "past": {
          "few": "{0} тижні тому",
          "many": "{0} тижнів тому",
          "one": "{0} тиждень тому",
          "other": "{0} тижня тому"
        }
      },
      "week-narrow": {
        "-1": "минулого тижня",
        "0": "цього тижня",
        "1": "наступного тижня",
        "future": {
          "few": "за {0} тиж.",
          "many": "за {0} тиж.",
          "one": "за {0} тиж.",
          "other": "за {0} тиж."
        },
        "past": {
          "few": "{0} тиж. тому",
          "many": "{0} тиж. тому",
          "one": "{0} тиж. тому",
          "other": "{0} тиж. тому"
        }
      },
      "week-short": {
        "-1": "мин. тижня",
        "0": "цього тижня",
        "1": "наст. тижня",
        "future": {
          "few": "через {0} тиж.",
          "many": "через {0} тиж.",
          "one": "через {0} тиж.",
          "other": "через {0} тиж."
        },
        "past": {
          "few": "{0} тиж. тому",
          "many": "{0} тиж. тому",
          "one": "{0} тиж. тому",
          "other": "{0} тиж. тому"
        }
      },
      "year": {
        "-1": "минулого року",
        "0": "цього року",
        "1": "наступного року",
        "future": {
          "few": "через {0} роки",
          "many": "через {0} років",
          "one": "через {0} рік",
          "other": "через {0} року"
        },
        "past": {
          "few": "{0} роки тому",
          "many": "{0} років тому",
          "one": "{0} рік тому",
          "other": "{0} року тому"
        }
      },
      "year-narrow": {
        "-1": "торік",
        "0": "цього року",
        "1": "наст. р.",
        "future": {
          "few": "за {0} р.",
          "many": "за {0} р.",
          "one": "за {0} р.",
          "other": "за {0} р."
        },
        "past": {
          "few": "{0} р. тому",
          "many": "{0} р. тому",
          "one": "{0} р. тому",
          "other": "{0} р. тому"
        }
      },
      "year-short": {
        "-1": "торік",
        "0": "цьогоріч",
        "1": "наст. року",
        "future": {
          "few": "через {0} р.",
          "many": "через {0} р.",
          "one": "через {0} р.",
          "other": "через {0} р."
        },
        "past": {
          "few": "{0} р. тому",
          "many": "{0} р. тому",
          "one": "{0} р. тому",
          "other": "{0} р. тому"
        }
      }
    },
    "locale": "uk"
  });
}